// Independent controller adapted from the source wj-accordion section.
(() => {
  if (customElements.get('wj-accordion') && customElements.get('yg-accordion')) return;
  class PDPAccordion extends HTMLElement {
    connectedCallback() {
      this.classPrefix = this.localName === 'yg-accordion' ? 'yg' : 'wj';
      this.mobile = window.innerWidth < 1025;
      this.onResize = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.updateMode(), 150);
      };
      this.onColor = (event) => {
        if (this.classPrefix === 'wj' && typeof event.detail?.index === 'number') this.filter(String(event.detail.index));
      };
      this.onEnter = (event) => this.activate(event.currentTarget);
      this.onKey = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.activate(event.currentTarget);
        }
      };
      this.items = [...this.querySelectorAll(`.${this.classPrefix}-accordion-item`)];
      this.items.forEach((item) => {
        item.addEventListener('mouseenter', this.onEnter);
        item.addEventListener('focusin', this.onEnter);
        item.addEventListener('keydown', this.onKey);
      });
      window.addEventListener('resize', this.onResize);
      document.addEventListener('wj-color-switch', this.onColor);
      this.filter('0');
    }

    disconnectedCallback() {
      clearTimeout(this.resizeTimer);
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('wj-color-switch', this.onColor);
      this.items.forEach((item) => {
        item.removeEventListener('mouseenter', this.onEnter);
        item.removeEventListener('focusin', this.onEnter);
        item.removeEventListener('keydown', this.onKey);
      });
      this.destroySwiper();
    }

    filter(group) {
      this.destroySwiper();
      this.items.forEach((item) => {
        const visible = this.classPrefix === 'yg' || (item.dataset.colorGroup || '0') === group;
        item.style.display = visible ? '' : 'none';
        item.classList.toggle('swiper-slide', visible);
        item.classList.remove('active');
        item.tabIndex = visible && !this.mobile ? 0 : -1;
      });
      this.visibleItems = this.items.filter((item) => item.style.display !== 'none');
      this.current = this.visibleItems[0];
      const inner = this.querySelector(`.${this.classPrefix}-accordion-item-inner`);
      if (this.classPrefix === 'wj') {
        inner?.style.setProperty('--active-flex', this.visibleItems.length);
        inner?.classList.toggle('has-scroll', this.visibleItems.length > 3);
      }
      if (this.mobile) this.initSwiper();
      else this.activate(this.current, false);
    }

    updateMode() {
      const mobile = window.innerWidth < 1025;
      if (mobile === this.mobile) return;
      this.mobile = mobile;
      this.items.forEach((item) => {
        item.classList.remove('active');
        item.tabIndex = item.style.display !== 'none' && !mobile ? 0 : -1;
      });
      if (mobile) this.initSwiper();
      else {
        this.destroySwiper();
        this.activate(this.current || this.visibleItems[0], false);
      }
    }

    activate(item, scroll = true) {
      if (this.mobile || !item || item.style.display === 'none') return;
      this.items.forEach((entry) => {
        entry.classList.toggle('active', entry === item);
        this.controlVideo(entry, entry === item);
      });
      this.current = item;
      if (scroll && (this.classPrefix === 'yg' ? this.items.length > 3 : this.querySelector(`.${this.classPrefix}-accordion-item-inner.has-scroll`))) {
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    controlVideo(item, play) {
      const video = item?.querySelector('yg-video');
      if (play) video?.playVideo?.();
      else video?.pauseVideo?.();
    }

    initSwiper() {
      if (this.swiper || this.classList.contains(`${this.classPrefix}-accordion-folding-card`)) return;
      const container = this.querySelector(`.${this.classPrefix}-accordion-item-container`);
      if (!container || !window.Swiper) return;
      this.swiper = new Swiper(container, {
        spaceBetween: 16,
        slidesPerView: 1.2,
        autoHeight: true,
        breakpoints: {
          220: { slidesPerView: 1.2, spaceBetween: 16 },
          500: { slidesPerView: 1.8, spaceBetween: 16 },
          990: { slidesPerView: 1.8, spaceBetween: 16 }
        },
        on: {
          slideChange: () => {
            this.items.forEach((item) => this.controlVideo(item, false));
            this.controlVideo(container.querySelector('.swiper-slide-active'), true);
          }
        }
      });
    }

    destroySwiper() {
      this.swiper?.destroy(true, true);
      this.swiper = null;
    }
  }
  if (!customElements.get('wj-accordion')) customElements.define('wj-accordion', PDPAccordion);
  if (!customElements.get('yg-accordion')) customElements.define('yg-accordion', class extends PDPAccordion {});
})();
